import { PREFIX, URIType } from "../uri";

function expandRange(start: number, end: number) {
  const nums: number[] = [];
  for (let i = start; i <= end; i++) {
    nums.push(i);
  }
  return nums;
}

function contractRange(nums: number[]) {
  const start = Math.min(...nums);
  const end = Math.max(...nums);
  return [start, end];
}

export class FrameSequenceURI {
  type: URIType.FrameSequence = URIType.FrameSequence;
  deviceId: string;
  recordingId: string;
  trackId: string;
  frameNo: number[];

  static parse(text: string) {
    const parts = text.split(":");
    if (parts[1] === "recording" && parts[6] === "frame") {
      const [, , deviceId, recordingId, , trackId, , frameId] =
        parts.map(decodeURIComponent);

      const range = frameId.split("-").map(parseFloat);
      const frameNos = expandRange(range[0], range[1]);

      return new FrameSequenceURI(deviceId, recordingId, trackId, frameNos);
    }

    return null;
  }

  static fromString(text: string) {
    const uri = FrameSequenceURI.parse(text);
    if (!uri) {
      throw new Error("Not FrameSequenceURI");
    }
    return uri;
  }

  constructor(
    deviceId: string,
    recordingId: string,
    trackId: string,
    frameNo: number[]
  ) {
    this.deviceId = deviceId;
    this.recordingId = recordingId;
    this.trackId = trackId;
    this.frameNo = frameNo;
  }

  get frameId() {
    return contractRange(this.frameNo).join("-");
  }

  toString(): string {
    return [
      PREFIX,
      "recording",
      this.deviceId,
      this.recordingId,
      "track",
      this.trackId,
      "frame",
      this.frameId,
    ]
      .map(encodeURIComponent)
      .join(":");
  }
}
